import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import styles from './CallCenterAssistance.module.css'
import logoUrl from '@/assets/misc/img_taxfyle-symbol.svg'
import { formatUSPhoneNumber } from '@/utils/phone-number-util'
import { StyledLink } from '@/components/Link'
import { Icon } from '@/components/Icon'

interface CallSalesRepDialogProps {
  isOpen: boolean
  onClose: () => void
  phoneNumber: string
}

export function CallSalesRepDialog({
  isOpen,
  onClose,
  phoneNumber,
}: CallSalesRepDialogProps) {
  return (
    <ModalDialog size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalDialogHeader textAlign="center">
        <img className={styles.logoImage} src={logoUrl} alt="Taxfyle logo" />
        <ModalDialogTitle>It's time to talk, call us now</ModalDialogTitle>
        <ModalDialogDescription>
          We are ready to assist you: Monday - Friday, 9am - 5pm EST
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent>
        <div className={styles.content}>
          <StyledLink href={`tel:${phoneNumber}`} target="_self">
            <div className={styles.phoneNumber}>
              <Icon name="call-start-call" />

              <div>{formatUSPhoneNumber(phoneNumber)}</div>
            </div>
          </StyledLink>
        </div>
      </ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button label="Close" variant="outline" onPress={onClose} />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
